import React from "react"

interface CircleWavyCheckIconProps {
  width?: number
  height?: number
  borderColor?: string
  borderWidth?: number
  fill?: string
  className?: string
}

const CircleWavyCheckIcon: React.FC<CircleWavyCheckIconProps> = ({
  width = 21,
  height = 21,
  borderColor = "#2D92FF",
  borderWidth = 1.75,
  fill = "#2D92FF",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.9375 17.0625C3.0625 16.1875 3.65625 14.375 3.20312 13.2812C2.75 12.1875 1 11.2188 1 10.5C1 9.78125 2.73438 8.84375 3.20312 7.71875C3.67188 6.59375 3.0625 4.8125 3.9375 3.9375C4.8125 3.0625 6.625 3.65625 7.71875 3.20312C8.8125 2.75 9.78125 1 10.5 1C11.2188 1 12.1562 2.73438 13.2812 3.20312C14.4062 3.67188 16.1875 3.0625 17.0625 3.9375C17.9375 4.8125 17.3438 6.625 17.7969 7.71875C18.25 8.8125 20 9.78125 20 10.5C20 11.2188 18.2656 12.1562 17.7969 13.2812C17.3281 14.4062 17.9375 16.1875 17.0625 17.0625C16.1875 17.9375 14.375 17.3438 13.2812 17.7969C12.1875 18.25 11.2188 20 10.5 20C9.78125 20 8.84375 18.2656 7.71875 17.7969C6.59375 17.3281 4.8125 17.9375 3.9375 17.0625Z"
        fill={fill}
        stroke={borderColor}
        strokeWidth={borderWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 8.25L9.25 13.5L6.5 10.75"
        stroke="white"
        strokeWidth={borderWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CircleWavyCheckIcon
